export default [{"url":"https://softhub-0.api.invexerp.io","name":"Branch 1","port":"6530","isStore":true,"isHQ":true}]